import { Classes, ProgressBar, ProgressBarProps } from "@blueprintjs/core";
import { rgba } from "polished";
import React from "react";
import styled, { DefaultTheme } from "styled-components";

/** Opacity applied to the subtle-button background to get the empty-track color. */
export const PROGRESS_BAR_TRACK_OPACITY = 0.3;

/**
 * The progress bar's empty-track color. Exported so meters
 * that have custom fills can match it exactly.
 */
export const progressBarTrackColor = (
  theme: DefaultTheme,
  opacity: number = PROGRESS_BAR_TRACK_OPACITY,
): string => rgba(theme.button.subtleOrMinimal.none.backgroundColor, opacity);

const StyledProgressBar = styled(ProgressBar)<{
  $small?: boolean;
}>`
  ${({ $small }) =>
    $small &&
    `height: 4px;
  `}
  background: ${({ theme }) => progressBarTrackColor(theme)};
  &.${Classes.INTENT_PRIMARY} {
    .${Classes.PROGRESS_METER} {
      background-color: ${({ theme }) => theme.intent.PRIMARY};
    }
  }
  &.${Classes.INTENT_SUCCESS} {
    .${Classes.PROGRESS_METER} {
      background-color: ${({ theme }) => theme.intent.SUCCESS};
    }
  }
  &.${Classes.INTENT_WARNING} {
    .${Classes.PROGRESS_METER} {
      background-color: ${({ theme }) => theme.intent.WARNING};
    }
  }
  &.${Classes.INTENT_DANGER} {
    .${Classes.PROGRESS_METER} {
      background-color: ${({ theme }) => theme.intent.DANGER};
    }
  }
`;

export type HexProgressBarProps = ProgressBarProps & {
  $small?: boolean;
};

/**
 * https://blueprintjs.com/docs/#core/components/progress-bar
 */
export const HexProgressBar: React.ComponentType<HexProgressBarProps> =
  React.memo(function HexProgressBar({ $small, ...props }) {
    return (
      <StyledProgressBar
        $small={$small}
        animate={false}
        stripes={false}
        {...props}
      />
    );
  });
